module.exports = "/_next/static/images/zhinengjianzhan@2x-339ee905118d7f3b5c4b792e2b59925e.png";